module.exports = __webpack_public_path__ + "img/gravatar.16065c81.svg";